export default __webpack_public_path__ + "media/zurb/img/home/home-work-paysa-d2b3bec9820f1082ae946ef6871195a3.png";